import { Typography } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { responsive } from '@/utils';

import type { InfoGroupColumnCount } from './infoGroupCard.types.ts';

export const InfoGroupGrid = styled.div<{ $columns: InfoGroupColumnCount }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  gap: ${responsive.spacing['2xlarge']};
  width: 100%;
`;

export const StyledCustomValue = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  margin-top: ${responsive.spacing.small};
`;

export const StyledValueText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
